import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material'
import { Stack } from '@mui/system'
import { mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import { useMemo } from 'react'
import { feedbackDialogStore } from '@/stores/feedback-dialog.store'
import { Icon } from '../atoms/Icon'

type IconProps = {
  path: string
  color: 'primary' | 'error' | 'info' | 'success'
}

export const FeedbackDialog = () => {
  const { type, title, open, closeDialog } = feedbackDialogStore(
    ({ type, title, open, closeDialog }) => ({
      type,
      title,
      open,
      closeDialog,
    }),
  )

  const iconProps: IconProps = useMemo(() => {
    switch (type) {
      case 'success':
        return { path: mdiCheck, color: 'success' }

      case 'error':
        return { path: mdiAlertCircleOutline, color: 'error' }

      default:
        return { path: '', color: 'primary' }
    }
  }, [type])

  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      PaperProps={{ sx: { p: 3 } }}
      fullWidth
      maxWidth="sm"
      keepMounted
    >
      <DialogContent sx={{ pt: 0 }}>
        <Stack spacing={4} alignItems="center">
          <Icon path={iconProps.path} size={3} color={iconProps.color} />

          <Typography variant="h6" fontWeight={700}>
            {title}
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button variant="contained" size="large" onClick={closeDialog}>
          fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
